'use strict';

var constants = require('./constants');
var template = require('./util/template');

/**
 * Injects the incontext experience (mask, help text + mini browser) into the <body>
 */
function injectIncontext(options, config) {
    options = options || {};

    var incontextMarkup = template.render(constants.TEMPLATES.incontext, {
        error: options.error,
        secureWindow: config.secureWindow,
        continueLink: config.continueLink,
        closeWindow: constants.closeWindow
    });

    var incontextWrapper = document.createElement('div');
    incontextWrapper.id = config.name;
    incontextWrapper.innerHTML = incontextMarkup;

    document.body.appendChild(incontextWrapper);
}

/**
 * Injects the loading interstitial page into "el"
 */
function injectLoadingInterstitial(el) {
    var loadingMarkup = template.render(constants.TEMPLATES.loading, {});

    el.write(loadingMarkup);
}

module.exports = {
    injectIncontext: injectIncontext,
    injectLoadingInterstitial: injectLoadingInterstitial
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/dom.js
 ** module id = 11
 ** module chunks = 0
 **/